import { ApplicationConfig, inject, provideAppInitializer, provideBrowserGlobalErrorListeners, provideZonelessChangeDetection } from '@angular/core';
import { provideRouter, withComponentInputBinding } from '@angular/router';

import { routes } from './app.routes';
import { provideHttpClient, withInterceptors, withXhr } from '@angular/common/http';
import { APP_CONFIG, AppConfigService, authInterceptor, errorInterceptor, firebaseProviders, loaderInterceptor } from '@shared';
import { setFirebaseConfig } from '@shared/core/firebase/firebase.config';
import { provideMonacoEditor } from 'ngx-monaco-editor-v2';

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideZonelessChangeDetection(),
    provideRouter(routes, withComponentInputBinding()),
    provideHttpClient(withXhr(), withInterceptors([loaderInterceptor, errorInterceptor, authInterceptor])),
    ...firebaseProviders,
    provideMonacoEditor({ baseUrl: 'assets/monaco/vs' }),

    provideAppInitializer(async () => {
      const appConfigService = inject(AppConfigService);

      const firebaseRes = await fetch('assets/firebase-config.json');
      if (!firebaseRes.ok) throw new Error(`Failed to load firebase-config.json: ${firebaseRes.status}`);
      const firebaseConfig = await firebaseRes.json();
      setFirebaseConfig(firebaseConfig);

      await appConfigService.load();
      console.log("Initializer finished, config loaded");
    }),


    {
      provide: APP_CONFIG,
      useFactory: () => {
        const configService = inject(AppConfigService);
        console.log("app config");
        console.log("Login service - providing app config");
        return configService.config;

      }
    },

  ]
};
